module.exports = __webpack_public_path__ + "img/48.4.NH3-N.573dc211.png";